import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Importing components
import { PlayerNotFound } from '../../components/player/player-not-found';
import { PlayerSkeleton } from '../../components/player/player-skeleton';
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
import { useTranslation } from 'react-i18next';
// Importing store
import { useMediaStore } from '../../store/media.store';
import { usePlayerStore } from '../../store/player.store';
import { PlayerType } from '../../types/player';
// Importing 3rd party dependencies
import { Fragment, useRef } from 'react';
import ReactPlayer from 'react-player/lazy';
// ----------------------------------------------------------------------
export const PlayerContent = (props) => {
    // Destructuring props
    const { type } = props;
    // Adding hooks
    const { t } = useTranslation();
    // Adding data handler
    const { available, chapter, duration, error, muted, player, seeking, playing, volume, setAvailable, setBuffering, setChapter, setDuration, setEnded, setError, setLoaded, setPlayed, setPlayer, setPlaying, } = usePlayerStore(useShallow((state) => ({
        available: state.available,
        chapter: state.chapter,
        duration: state.duration,
        error: state.error,
        muted: state.muted,
        player: state.player,
        playing: state.playing,
        seeking: state.seeking,
        volume: state.volume,
        setAvailable: state.setAvailable,
        setBuffering: state.setBuffering,
        setChapter: state.setChapter,
        setDuration: state.setDuration,
        setEnded: state.setEnded,
        setError: state.setError,
        setLoaded: state.setLoaded,
        setPlayed: state.setPlayed,
        setPlayer: state.setPlayer,
        setPlaying: state.setPlaying,
    })));
    const { media } = useMediaStore(useShallow((state) => ({
        media: state.media,
    })));
    // Adding player ref
    // We use this to reference the player instance for certain actions, i.e. using controls
    const playerRef = useRef(null);
    if (player.current !== null && playerRef.current !== null) {
        setPlayer(playerRef);
    }
    // Adding progress handler
    // The react player needs this for handling internal state
    const handleProgress = (progress) => {
        if (!seeking) {
            // Updating loaded and played state
            setLoaded(progress.loaded);
            setPlayed(progress.played);
            // Adding current chapter to state
            const currentChapter = media === null || media === void 0 ? void 0 : media.chapters.find((chapter) => progress.played <= chapter.to / 1000 / duration);
            if (currentChapter)
                setChapter(currentChapter);
        }
    };
    // Restructuring captions data
    const tracks = [];
    for (const caption of (media === null || media === void 0 ? void 0 : media.captions) || []) {
        tracks.push({
            id: caption.srcLang,
            kind: 'subtitles',
            label: t(`languages.${caption.srcLang}`),
            src: caption.src,
            srcLang: caption.srcLang,
        });
    }
    return (_jsxs(Fragment, { children: [!available && _jsx(PlayerSkeleton, { type: type }), !error && media ? (_jsx(ReactPlayer, { ref: player, config: {
                    file: {
                        tracks,
                    },
                }, controls: false, fallback: _jsx(PlayerSkeleton, { type: type }), height: "100%", muted: muted, playing: playing, url: media.url, volume: volume, width: "100%", onBuffer: () => setBuffering(true), onBufferEnd: () => setBuffering(false), onDuration: setDuration, onEnded: () => {
                    setPlaying(false);
                    setEnded();
                }, onError: setError, onPlay: () => setPlaying(true), onProgress: handleProgress, onReady: () => {
                    duration === 0 && setAvailable(true);
                }, style: {
                    display: available ? 'flex' : 'none',
                } })) : (_jsx(PlayerNotFound, { type: PlayerType.video }))] }));
};
